import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiClientError } from '../http/api-error.types';
import { AuthorizationService } from '../auth/authorization.service';
import { PermissionRequirement } from '../auth/authorization.types';
import { Auth } from '../services/auth';

export const permissionGuard: CanActivateFn = async (route) => {
  const authorization = inject(AuthorizationService);
  const router = inject(Router);
  const auth = inject(Auth);
  const requirement = route.data?.['permission'] as PermissionRequirement | undefined;

  if (!requirement) {
    return true;
  }

  try {
    const currentUser = await authorization.ensureLoaded();

    if (currentUser?.isSuspended) {
      auth.setLoginBlockReason('suspended');
      auth.expireSession();
      return router.createUrlTree(['/login'], {
        queryParams: { reason: 'suspended' },
      });
    }
  } catch (error) {
    if (isSuspendedAccessError(error)) {
      auth.setLoginBlockReason('suspended');
      auth.expireSession();
      return router.createUrlTree(['/login'], {
        queryParams: { reason: 'suspended' },
      });
    }

    return router.parseUrl('/login');
  }

  return authorization.isAllowed(requirement)
    ? true
    : router.parseUrl('/login');
};

function isSuspendedAccessError(error: unknown) {
  if (!(error instanceof ApiClientError)) {
    return false;
  }

  if (error.apiError.status !== 403) {
    return false;
  }

  return error.apiError.message.trim().toLowerCase().includes('suspend');
}
